var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    viewBox: "0 0 52 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_2468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6827 29.5321L34.4551 46.7658L51.6827 63.9995H31.9967L14.763 46.7658L31.9967 29.5321H51.6827ZM31.9967 0L0 31.9967L9.84608 41.8427L51.6827 0H31.9967V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.769 46.7657L24.609 56.6118L51.6826 29.532H31.9966L14.769 46.7657Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_227_2468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6827 29.5321L34.4551 46.7658L51.6827 63.9995H31.9967L14.763 46.7658L31.9967 29.5321H51.6827ZM31.9967 0L0 31.9967L9.84608 41.8427L51.6827 0H31.9967V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_227_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9967 0H51.6827L9.84608 41.8427L0 31.9967L31.9967 0Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_227_2468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6827 29.5321L34.4551 46.7658L51.6827 63.9995H31.9967L14.763 46.7658L31.9967 29.5321H51.6827ZM31.9967 0L0 31.9967L9.84608 41.8427L51.6827 0H31.9967V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_227_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6091 56.6119L31.9968 63.9934H51.6828L34.4552 46.7659L24.6091 56.6119Z",
    fill: "#03569B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_227_2468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6827 29.5321L34.4551 46.7658L51.6827 63.9995H31.9967L14.763 46.7658L31.9967 29.5321H51.6827ZM31.9967 0L0 31.9967L9.84608 41.8427L51.6827 0H31.9967V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_227_2468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2119 51.5534L34.4552 46.7659L24.6091 56.6119L39.2119 51.5534Z",
    fill: "url(#paint0_linear_227_2468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7681 46.7624L24.6144 36.916L34.4613 46.7624L24.6144 56.6088L14.7681 46.7624Z",
    fill: "#16B9FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2468",
    x1: 27.4825,
    y1: 58.5121,
    x2: 34.8157,
    y2: 51.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterLogo);
export default __webpack_public_path__ + "static/media/flutter-logo.a7304925d7abd0e8ba0ed73c25b4ef46.svg";
export { ForwardRef as ReactComponent };